export const OVERALL_RANKING_COLUMN_STATE_KEY = 'overallRankingTableColumnState'
export const USER_MANAGEMENT_COLUMN_STATE_KEY = 'userManagementTableColumnState'
export const TICKER_MANAGEMENT_COLUMN_STATE_KEY =
  'tickerManagementTableColumnState'
export const IDEA_LIST_COLUMN_STATE_KEY = 'ideaListTableColumnState'
export const IDEA_HISTORY_COLUMN_STATE_KEY = 'ideaHistoryTableColumnState'
export const STATISTICS_LIST_COLUMN_STATE_KEY = 'statisticsListTableColumnState'
